module.exports = __webpack_public_path__ + "static/media/insect(26).a22012bd.PNG";